export const TENANTS = 'tenant';
export const SHORT_TENANTS = 'short_term_tenant';
export const OWNER = 'owner';

export const RENTAL_CLIENT_TYPES = [TENANTS, SHORT_TENANTS];
